var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:("favorite-products-counter " + _vm.additionalClass),attrs:{"href":_vm.url}},[_c('div',{staticClass:"favorite-products-counter__content"},[_vm._v(_vm._s(_vm.count))])])}
var staticRenderFns = []

export { render, staticRenderFns }